<template>
    <div class="containerPage">
        <div class="header-view">
             <Case1HeaderSearch
            @reset="resetHandel"
            @inquire="inquireHandel"
            ></Case1HeaderSearch>
        </div>
       
       <section>
           <!-- 聊天列表 -->
           <div class="chat-list">
                <ChatUserList
                @propsUserItem="activeHande" 
                :userDataList="userDataListCopy">
                </ChatUserList>
           </div>
           <!-- 聊天窗口 -->
           <div class="chat-content">
                <DocNavTab
                :userTabsData="userTabsDataList"
                @tabActive="tabActiveHandel"
                @removeActive="removeActiveHandel"
                >
               </DocNavTab>
               <IM :IMInfo="IMInfo" :chatPatientName="rightData.patientName" :showAdd='false' pageName='case-4' @refreshPatientList="inquireHandel" style="height: calc(100% - 40px)"></IM>
           </div>
           <!-- 对照录入 -->
           <div>
               <RightContent :rightInfo="rightData"/>
           </div>
       </section>
    </div>
</template>

<script>
import IM from '../../../treatment/components/IM/IM.vue'
import DocNavTab from '../../../treatment/components/DocNavTap'
import RightContent from '../../components/RightContent/index.vue'
import ChatUserList from '../../components/ChatUserList/index.vue'
import Case1HeaderSearch from '../../components/Case1HeaderSearch/index.vue'
import {nursing_service_im,nursing_service_info} from './index'
import ImList from '../../../treatment/common/index'
export default {
    name:'Case1',
    mixins:[ImList],
    data(){
        return{
            formDataValue:{},//暂存form数据
            userTabsDataList:[],//当前所有聊天的用户列表
            userDataList:[],//用户列表
            rightData:{},//右侧模块数据
            IMInfo:Object.create(null),   // IM 模块数据     
            setintervalTime:null              
        }
    },
    components:{
        IM,
        DocNavTab,
        ChatUserList,
        RightContent,
        Case1HeaderSearch,
    },
    sockets: {
      nursingServiceIm(data) {
        this.inquireHandel()
      }
    },
    created(){},
    methods:{
        
        /**
         * @description: 过滤没有删除的用户
         * @param {*}
         * @return {*}
         */
        removeActiveHandel(event){
            this.userTabsDataList = event;
        },
        /**
         * @description: 查询通知
         * @param {*}
         * @return {*}
         */
        inquireHandel(event){
          if (event) {
            this.formDataValue = event;
          } else {
            delete this.formDataValue.init
          }
            nursing_service_im(this.formDataValue).then(res=>{
                if(res.code == 0 ){
                    //TODO 拿到IM的消息 进行拼接房间id
                    if(res.data.length){
                        this.userDataList = res.data.map(item=>{
                            item.imId = 'GROUP' + item.groupCode;
                            return item
                        });
                        //首次加载默认用户列表的第一个
                        if(this.formDataValue.hasOwnProperty('init')){
                            this.activeHande(this.userDataList[0]);
                        }
                    }else{
                        this.userDataList = [];
                    }
                }
            });
            //TODO 轮询调用接口
            // clearInterval(this.setintervalTime)
            // const tiemFn = ()=>{
            //     nursing_service_im(this.formDataValue).then(res=>{
            //         if(res.code == 0 ){
            //             //TODO 拿到IM的消息 进行拼接房间id
            //             if(res.data.length){
            //                 this.userDataList = res.data.map(item=>{
            //                     item.imId = 'GROUP' + item.groupCode;
            //                     return item
            //                 });
            //             }else{
            //                 this.userDataList = [];
            //             }
            //         }
            //     })
            // };
            
            // this.setintervalTime = setInterval(()=>{
            //     tiemFn()
            // },10000)
        },

        /**
         * @description: 重置通知
         * @param {*}
         * @return {*}
         */
        resetHandel(event){
            this.inquireHandel(event)
        },

        /**
         * @description: Navtap 的选中和删除都会触发这个方法，拿到选中都用户数据
         * @param {*}
         * @return {*}
         */
        tabActiveHandel(event){
            //TODO 讲好友列表数据传递给im组件
            this.IMInfo = {
                ...event,
                noThird: true
            };
            this.$socket.emit('setGroupCode', event.imId.slice(5), data => {})
            this.inquireHandel()
            //TODO 获取当前用户 的 右侧信息
            nursing_service_info( event.nursingServiceId ).then(res=>{
                if(res.code == 0){
                    this.rightData = res.data
                }
            })
        },

        /**
         * @description: chatUserList子组件传递过来的属性 点击好友列表进入问诊房间 进入问诊房间
         * @param {*}
         * @return {*}
         */
        activeHande(event){
            this.$store.commit('patientInfo',event)
            this.$socket.emit("setGroupCode", event.imId.slice(5), data => {});
            this.inquireHandel()
            event.unreadCount = 0 ;
            if(this.userTabsDataList.some(item=>item.id == event.id)){
                const Index = this.userTabsDataList.findIndex(item=>item.id == event.id);
                this.userTabsDataList.splice(Index,1);
                this.userTabsDataList.unshift(event)
            }else{
                this.userTabsDataList.unshift(event);
            }
            //TODO 讲好友列表数据传递给im组件
            this.IMInfo = {
                ...event,
                // 不展示医护对话tab
                noThird: true
            };
            
            //TODO 获取当前用户的右侧信息
            nursing_service_info( event.nursingServiceId ).then(res=>{
                if(res.code == 0){
                    this.rightData = res.data
                }
            })
            
        },
    },
    beforeDestroy(){
        clearInterval(this.setIntervalTime)
    }
}
</script>
<style scoped lang="less">
.containerPage{
    height: 100%;
    .header-view{
        background-color: #fff;
        padding: 16px;
    }
    section{
        position: absolute;
        left: 0;
        top: 120px;
        width: 100%;
        height: calc(100% - 120px);
        background-color: #F8F8F8;
        padding:20px;
        display: flex;
        .chat-list{
            width: 328px;
            height: 100%;
            background-color: #fff;
            border-radius: 6px;
        }
        .chat-content{
            flex: 1;
            min-width: 400px;
            height: 100%;
            background-color: #fff;
            border-radius: 6px;
            margin: 0 16px;
        }
        div:nth-child(3){
            width: 504px;
            height: 100%;
            background-color: #fff;
        }
    }
}
</style>